import React from 'react';
import Reflux from 'reflux';
import GongqiFormItem from './GongqiFormItem';
import FormItemConst from './FormItemConst';
import {FocusSetStore} from '../stores/FocusStore';
import {SetButtonStyleStore} from '../stores/CmdTypeStore';
import {CmdUpdateControlAllowEditStore,DsAllowEditStore,CmdUpdateControlLabelStore,CmdUpdateControlVisibleStore} from '../stores/CmdTypeStore';
import {ButtonShortCutStore} from '../stores/CommandStore';
import FocusActions from '../actions/FocusActions';
import FormItemUtil from '../utils/FormItemUtil';

require('../styles/FormItemButton.css');
/*{this.props.xml.name}*/
class FormItemButtonMenu extends GongqiFormItem
{
	constructor(props) {
		super(props);
		this.dropdownShowed = false;
		if(!this.props.forLookup)
		{
			this.unsubscribeCmdUpdateControlAllowEditStore = CmdUpdateControlAllowEditStore.listen(this.onCmdUpdateControlAllowEditStore.bind(this));
			this.unsubcribeCmdUpdateControlVisibleStore = CmdUpdateControlVisibleStore.listen(this.onCmdUpdateControlVisible.bind(this));
			this.unsubscribeCmdDsAllowEditStore = DsAllowEditStore.listen(this.onDsAllowEdit.bind(this));
			this.unsubscribeButtonShortCutStore = ButtonShortCutStore.listen(this.onShortCut.bind(this));
		}
		this.unsubscribeFocusSetStore = FocusSetStore.listen(this.onFocusSet.bind(this));
		this.unsubscribeSetButtonStyleStore = SetButtonStyleStore.listen(this.onSetButtonStyle.bind(this));
		this.unsubscribeCmdUpdateControlLabelStore = CmdUpdateControlLabelStore.listen(this.onCmdUpdateControlLabel.bind(this));
		
		this.state.devStyles = {};
		this.state.label = this.props.label;
	}

	onShortCut(keyCodeStr)
	{
		return;
		if(!this.props.dropdown)return;
		let lilist = this.props.dropdown.find(">li");
		for(let i = 0;i<lilist.length;i++)
		{
			let $li = $(lilist[i]);
			let controlId = $li.attr("controlId");
			let formItemButtonControl = FormItemUtil.getFormItemControl(controlId,this.props.forLookup);
			let shortCut = formItemButtonControl.getProperty_ShortCut();
			if(shortCut == keyCodeStr)
			{
				formItemButtonControl.beforeOK({target:lilist[i]},true);
			}
		}
	}

	componentWillUnmount()
	{
		if(!this.props.forLookup)
		{
			this.unsubscribeCmdUpdateControlAllowEditStore();
			this.unsubscribeCmdDsAllowEditStore();
		}
		this.unsubscribeFocusSetStore();
		this.unsubscribeSetButtonStyleStore();
		this.unsubscribeCmdUpdateControlLabelStore();
	}

	componentDidMount()
	{
		var finalAllowEdit = this.props.control.getProperty_AllowEdit_Final();
		if(finalAllowEdit){$(this.btnMain).removeClass("disabled");$(this.dropdownbutton).removeClass("disabled")}
		else {$(this.btnMain).addClass("disabled");$(this.dropdownbutton).addClass("disabled");}
	}

	onCmdUpdateControlVisible(menuItemId,formId,names,isLookup){
		if(this.props.control && this.props.forLookup == isLookup && this.props.menuItemId == menuItemId
			&& this.props.formId == formId)
		{
			if(names.indexOf(this.props.xml.name) != -1){
				let nowVisible = this.state.visible;
				let finalVisible = this.props.control.getProperty_Visible_Final();

				this.setState({visible:finalVisible});
	
				if(finalVisible != nowVisible)
				{
					if(nowVisible == false && finalVisible == true)
					{
						this.visibleFlaseToTrue()
					}
				}
			}else{
				let lilist = this.props.dropdown.find(">li");
				for(let i = 0;i<lilist.length;i++)
				{
					let $li = $(lilist[i]);
					if(names.indexOf($li.attr("componentName")) != -1)
					{
						let controlId = $li.attr("controlId");
						let formItemButtonControl = FormItemUtil.getFormItemControl(controlId,this.props.forLookup);
					
						let finalVisible = formItemButtonControl.getProperty_Visible_Final();
					
						if(finalVisible)
						{
							$li.show()
						}else
						{
							$li.hide()
						} 
						break;
					}
					}
			}
		}
	}

	onCmdUpdateControlAllowEditStore(name,_allowEdit)
	{
		if(name == this.props.xml.name)
		{
			var finalAllowEdit = this.props.control.getProperty_AllowEdit_Final();
			if(finalAllowEdit){$(this.btnMain).removeClass("disabled");$(this.dropdownbutton).removeClass("disabled")}
			else {$(this.btnMain).addClass("disabled");$(this.dropdownbutton).addClass("disabled");}
		}
		else
		{
			let lilist = this.props.dropdown.find(">li");
			for(let i = 0;i<lilist.length;i++)
			{
				let $li = $(lilist[i]);
				if($li.attr("componentName") == name)
				{
					let controlId = $li.attr("controlId");
					let formItemButtonControl = FormItemUtil.getFormItemControl(controlId,this.props.forLookup);
				
					let finalAllowEdit = formItemButtonControl.getProperty_AllowEdit_Final();
				
					if(finalAllowEdit)
					{
						$li.removeClass("disabled").css({opacity:1});
					}else
					{
						$li.addClass("disabled").css({opacity:0.5});
					} 
					break;
				}
			}
		}
	}

	onCmdUpdateControlLabel(name,_label,moduleInstanceId)
	{
		if(name == this.props.xml.name && this.props.moduleInstanceId == moduleInstanceId)
		{
			this.setState({label:_label});
		}else{
			let lilist = this.props.dropdown.find(">li");
			for(let i = 0;i<lilist.length;i++)
			{
				let $li = $(lilist[i]);
				if($li.attr("componentName") == name)
				{
					let controlId = $li.attr("controlId");
					let formItemButtonControl = FormItemUtil.getFormItemControl(controlId,this.props.forLookup);
					if(formItemButtonControl.xml.name == name){
						$li.context.children[0].innerText = formItemButtonControl._cmdLabel;
					}
					break;
				}
			}
		}
	}

	onDsAllowEdit(groupAlias)
	{
		if(groupAlias == this.props.groupAlias)
		{
			var finalAllowEdit = this.props.control.getProperty_AllowEdit_Final();
			if(finalAllowEdit){$(this.btnMain).removeClass("disabled");$(this.dropdownbutton).removeClass("disabled");}
			else {$(this.btnMain).addClass("disabled");$(this.dropdownbutton).addClass("disabled");}
		}
		else
		{
			let lilist = this.props.dropdown.find(">li");
			for(let i = 0;i<lilist.length;i++)
			{
				let $li = $(lilist[i]);
				let controlId = $li.attr("controlId");
				let formItemButtonControl = FormItemUtil.getFormItemControl(controlId,this.props.forLookup);
				let finalAllowEdit = formItemButtonControl.getProperty_AllowEdit_Final();
				if(finalAllowEdit)$li.removeClass("disabled");else $li.addClass("disabled");
			}
		}
	}

	onFocusSet(formId,itemId,pre,init)
	{
		//alert(itemId + "  " + this.props.xml.id);
		if(this.props.formId == formId && this.props.xml.id == itemId)
		{
			$(this.btnMain).focus();
			//$(this.inputField).select();
		}
	}

	onSetButtonStyle(formId,name,buttonStyle)
	{
		if(this.props.xml.name == name && this.props.formId == formId)
		{
			this.setState({devStyles:buttonStyle});
		}
	}

	//当时此button在下拉框上 属于第三极IFrame
	testIframeToParentAction()
	{
		document.addEventListener("paste",function(e){alert("paste")});
		document.execCommand("paste");
		return;
		var _parentWindow = window.parent.window;
		if(_parentWindow)
		{
			if(typeof(_parentWindow.lookupReturnTest)=='function')
				_parentWindow.lookupReturnTest();
		}
		//window.parent.window.filterNodesBySubPage("SJLJ")
	}

	onKeyDownHandler(e)
	{
		if(9===e.keyCode)
		{
			//alert(e.shiftKey)
			e.preventDefault();
			FocusActions.focusChange(this.props.xml,e.shiftKey);
		}
	}

	showDropDown()
	{
		if($(this.btnMain).hasClass("disabled"))
		{
			return;
		}
		//dropdown要求是一个jquery对象
		if(this.dropdownShowed && this.props.dropdown)
		{
			this.props.dropdown.css("display","none");
			this.dropdownShowed = false;
			this.deAttachDropDownEvents();
			return false;
		}
		if(this.props.dropdown.parent().length == 0)
			this.props.dropdown.appendTo($('body'));
		this.attachDropDownEvents();
		this.dropdownShowed = true;
		this.setDropDownPosition();
		this.props.dropdown.css("display","block");
	}

	attachDropDownEvents()
	{
		$(document).one(
			'mousedown',this.mouseDownOutSideHandler.bind(this)
		);
		this.props.dropdown.find("a").one('click',this.itemClickHandler.bind(this));
	}

	deAttachDropDownEvents()
	{

	}

	itemClickHandler(e)
	{
		this.props.dropdown.css("display","none");
		this.dropdownShowed = false;
	}

	mouseDownOutSideHandler(e)
	{
		if (!(
			$(this.dropdownbutton).is(e.target) ||
			$(this.dropdownbutton).find(e.target).length ||
			$(this.btnMain).is(e.target) ||
			$(this.btnMain).find(e.target).length ||
			$(this.props.dropdown).is(e.target) ||
			$(this.props.dropdown).find(e.target).length
		)){
			this.props.dropdown.css("display","none");
			this.dropdownShowed = false;
		}
	}

	setDropDownPosition()
	{
		var lookupdiv = this.props.dropdown;
		
		var _inputwidth = $(this.btnMain).width() + $(this.dropdownbutton).width();
		var _inputHeight = $(this.btnMain).outerHeight(true);
		var _iframewidth = lookupdiv.width();
		
		var _iframeheight = lookupdiv.outerHeight(true);
		
		var _gwidth = $("#app").width();
		var _gheight = $("#app").height();
		if(_iframewidth>_gwidth)
		{
			_iframewidth = _gwidth;
			lookupdiv.css({width:_iframewidth+'px',overflow:"auto"});
		}
		else if(_iframewidth<_inputwidth)
		{
			_iframewidth = _inputwidth;
			lookupdiv.css({width:_iframewidth+'px',overflow:"auto"});
		}
		var _offset = $(this.btnMain).offset();
		var _y = _offset.top; 
		var _x = _offset.left;
		var _top = _y+_inputHeight;//$(this.btnMain).height();
		//alert('x:'+_x+'y:'+_y);
		//下方屏幕放不下
		if((_top+_iframeheight)>_gheight)
		{
			//上下都放不下 考虑缩减高度
			if(_iframeheight>_top)
			{
				//上方空间大
				if(_top>(_gheight/2))
				{
					let _newdivheight = (_top-1)+'px';
					//lookupdiv.css("height":_newdivheight);
					lookupdiv.height(_top-14-$(this.btnMain).height());
					//alert(_newdivheight);
					_top = '0px';
					//'-'+_newdivheight+'px';

				}
				else //下方空间大
				{
					//let _newdivheight = (_gheight-_y)+'px';
					lookupdiv.height(_gheight-_top);	
				}
			}
			else//下拉框置于上方
			{
				_top = (_top-_iframeheight-_inputHeight)+'px';
					//'-'+_iframeheight+'px';
			}
		}
		else
		{
			_top -= 2;
		}
		var _left = _x-((_iframewidth-_inputwidth)/2);
			//(_iframewidth-_inputwidth)/2;
		if(_left+_iframewidth>_gwidth)
			_left = _gwidth-_iframewidth-8;
		if(_left<0)_left = 0;
		lookupdiv.css({left:(_left+'px'),top:_top});
	}

	inputFieldFocus()
	{
		window.lastFocusUI = this.btn;
		FocusActions.currentGroupSet(this.props.groupAlias,this.props.formId);
	}
	
	render()
	{
		let _style = Object.assign({},this.props.customStyle);
		if(!_style)_style = {};

		_style["display"] = "flex";
		_style["flexDirection"] = "row";
		_style["alignItems"] = "flex-start";
		_style["margin"] = '2px';
		
		if(this.state.visible == false)
			if(this.state.hideInVisible == true) _style.display="none"; else _style.visibility="hidden";
		Object.assign(_style,this.state.devStyles);
		let btnInfo = this.props.iconClass?<button type="button" className="btn btn-info GongqiFormItemButtonMenu" ref={node => this.btnMain = node} 
												style={{padding:"1px 4px",flexGrow:'100',borderTopRightRadius:'0',borderBottomRightRadius:'0'}}
												onClick={this.showDropDown.bind(this)} onFocus={this.inputFieldFocus.bind(this)} onKeyDown={this.onKeyDownHandler.bind(this)}>
													<i className={this.props.iconClass}></i>&nbsp;{this.state.label}
											</button>
											:
											<button type="button" className="btn btn-info GongqiFormItemButtonMenu" ref={node => this.btnMain = node} 
												style={{padding:"1px 4px",flexGrow:'100',borderTopRightRadius:'0',borderBottomRightRadius:'0'}}
												onClick={this.showDropDown.bind(this)} onFocus={this.inputFieldFocus.bind(this)} onKeyDown={this.onKeyDownHandler.bind(this)}>
													{this.state.label}
											</button>
		return  <div style={_style} ref={node => this.btn = node}>
					{btnInfo}
					<button type="button" className="buttonMenuDropDown btn GongqiFormItemButtonMenu" ref={node => this.dropdownbutton = node} 
						style={{borderTopLeftRadius:'0',borderBottomLeftRadius:'0'}}
						onClick={this.showDropDown.bind(this)} onFocus={this.inputFieldFocus.bind(this)}>
						<i className={"fa fa-angle-down"} aria-hidden="true"></i>
						<span className="sr-only">Toggle Dropdown</span>
					</button>
				</div>;
	}
	
};

FormItemButtonMenu.defaultProps = {
};

export default FormItemButtonMenu;


// WEBPACK FOOTER //
// ./src/formItem/FormItemButtonMenu.js